import { Pipe, PipeTransform } from '@angular/core';
import { BusinessOwnerService } from '../business-owner/business-owner.service';
import { find, take, map, tap } from 'rxjs/operators';

@Pipe({ name: 'asyncBusinessOwnerEntity' })
export class AsyncBusinessOwnerEntityPipe implements PipeTransform {
    constructor(private businessOwnerService: BusinessOwnerService) {}

    transform(input: number) {
        return this.businessOwnerService
            .getAll()
            .pipe(map(entities => entities.find(v => v.id === Number(input))));
    }
}
